import { render, staticRenderFns } from "./InlineCardLabels.vue?vue&type=template&id=392e0848&scoped=true&"
import script from "./InlineCardLabels.vue?vue&type=script&lang=ts&"
export * from "./InlineCardLabels.vue?vue&type=script&lang=ts&"
import style0 from "./InlineCardLabels.vue?vue&type=style&index=0&id=392e0848&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "392e0848",
  null
  
)

export default component.exports